const TwitterIcon = ({ size = 24, color = 'currentColor', className = '', ...props }) => (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M18.9 1.125H22.581L14.541 10.338L24 22.875H16.5945L10.794 15.27L4.1565 22.875H0.474L9.0735 13.02L0 1.125H7.5945L12.837 8.0745L18.9 1.125ZM17.61 20.667H19.65L6.4845 3.2175H4.2975L17.61 20.667Z' fill='black' />
    </svg>

);

export default TwitterIcon;
